import { certificatesSettingsValueClass } from "../helpers/admin-certificates-settings-grid.helpers";
import { twMerge } from "tailwind-merge";

type Props = {
  children: string;
};

const CertificateNameCell = ({ children }: Props) => (
  <div className={twMerge("flex h-full min-h-10 items-center", certificatesSettingsValueClass)}>{children}</div>
);

export default CertificateNameCell;
